export default __webpack_public_path__ + "2f1eb59dd0318affbd7671946c7ead39.png";